// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { DocumentAnswerKey, DocumentAnswers, DocumentEditIssueType, Encounter, EncounterDocument, EncounterDocumentSectionOverride, EncounterPreview, NoteAIStep, Transcript } from "../../model/dto_scribe_encounter_pb.js";
import { NoteNumberValue, NoteTableRowValue, NoteTeethGroup, NoteToothMark, PartnerTemplatePartner } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from enum com.diagnocat.scribe.NoteLineOp
 */
export const NoteLineOp = proto3.makeEnum(
  "com.diagnocat.scribe.NoteLineOp",
  [
    {no: 0, name: "NoteLineOpInvalidValue"},
    {no: 1, name: "NoteLineOpDelete"},
    {no: 2, name: "NoteLineOpRestore"},
    {no: 3, name: "NoteLineOpSkip"},
    {no: 4, name: "NoteLineOpUnskip"},
    {no: 5, name: "NoteLineOpSetNote"},
    {no: 6, name: "NoteLineOpClearNote"},
  ],
);

/**
 * @generated from enum com.diagnocat.scribe.NoteSectionOp
 */
export const NoteSectionOp = proto3.makeEnum(
  "com.diagnocat.scribe.NoteSectionOp",
  [
    {no: 0, name: "NoteSectionOpInvalidValue"},
    {no: 1, name: "NoteSectionOpSkipRemaining"},
    {no: 2, name: "NoteSectionOpSetLineOrder"},
    {no: 3, name: "NoteSectionOpResetLineOrder"},
  ],
);

/**
 * @generated from enum com.diagnocat.scribe.NoteAddedBlockOp
 */
export const NoteAddedBlockOp = proto3.makeEnum(
  "com.diagnocat.scribe.NoteAddedBlockOp",
  [
    {no: 0, name: "NoteAddedBlockOpInvalidValue"},
    {no: 1, name: "NoteAddedBlockOpRemove"},
    {no: 2, name: "NoteAddedBlockOpRestore"},
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetRecordingCapabilitiesReq
 */
export const GetRecordingCapabilitiesReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetRecordingCapabilitiesReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetRecordingCapabilitiesResp
 */
export const GetRecordingCapabilitiesResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetRecordingCapabilitiesResp",
  () => [
    { no: 1, name: "DictationEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetEncounterReq
 */
export const GetEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ResolvePatientInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetEncounterResp
 */
export const GetEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetEncounterResp",
  () => [
    { no: 1, name: "Encounter", kind: "message", T: Encounter },
  ],
);

/**
 * At least one of PatientID or OrganizationID is required.
 *
 * @generated from message com.diagnocat.scribe.ListEncountersReq
 */
export const ListEncountersReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncountersReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "SchemaCode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "UpdatedAfter", kind: "message", T: Timestamp, opt: true },
    { no: 8, name: "UpdatedAfterID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "IncludeArchived", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "IncludeDeleted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "ResolvePatientInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListEncountersResp
 */
export const ListEncountersResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListEncountersResp",
  () => [
    { no: 1, name: "Encounters", kind: "message", T: EncounterPreview, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * Fields left unset keep their stored value.
 *
 * @generated from message com.diagnocat.scribe.UpdateEncounterReq
 */
export const UpdateEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "StaffMemberID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterResp
 */
export const UpdateEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.ArchiveEncounterReq
 */
export const ArchiveEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ArchiveEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ArchiveEncounterResp
 */
export const ArchiveEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ArchiveEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterReq
 */
export const RestoreEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreEncounterResp
 */
export const RestoreEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterReq
 */
export const DeleteEncounterReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteEncounterResp
 */
export const DeleteEncounterResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteEncounterResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterDocumentReq
 */
export const UpdateEncounterDocumentReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterDocumentReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Sections", kind: "message", T: EncounterDocumentSectionUpdate, repeated: true },
    { no: 4, name: "Approved", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateEncounterDocumentResp
 */
export const UpdateEncounterDocumentResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateEncounterDocumentResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.EncounterDocumentSectionUpdate
 */
export const EncounterDocumentSectionUpdate = proto3.makeMessageType(
  "com.diagnocat.scribe.EncounterDocumentSectionUpdate",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IssueTypes", kind: "enum", T: proto3.getEnumType(DocumentEditIssueType), repeated: true },
    { no: 4, name: "FeedbackText", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateLiveTranscriptionSessionReq
 */
export const CreateLiveTranscriptionSessionReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateLiveTranscriptionSessionReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateLiveTranscriptionSessionResp
 */
export const CreateLiveTranscriptionSessionResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateLiveTranscriptionSessionResp",
  () => [
    { no: 1, name: "Provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ClientSecret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ExpiresAt", kind: "message", T: Timestamp },
    { no: 5, name: "ConnectURL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.FillProtocolReq
 */
export const FillProtocolReq = proto3.makeMessageType(
  "com.diagnocat.scribe.FillProtocolReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TranscriptRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Transcript", kind: "message", T: Transcript },
    { no: 5, name: "ClientTimeZone", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.FillProtocolResp
 */
export const FillProtocolResp = proto3.makeMessageType(
  "com.diagnocat.scribe.FillProtocolResp",
  () => [
    { no: 1, name: "Answers", kind: "message", T: DocumentAnswers },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetDocumentAnswersReq
 */
export const GetDocumentAnswersReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentAnswersReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ClientTimeZone", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetDocumentAnswersResp
 */
export const GetDocumentAnswersResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetDocumentAnswersResp",
  () => [
    { no: 1, name: "Answers", kind: "message", T: DocumentAnswers },
  ],
);

/**
 * Block notes: Key.BlockID; Values for choice, multi_choice and list_ref; Text
 * for Other text, free text, or a text or context override; Clear empties the
 * block and locks it against AI (on a text block: the template wording,
 * locked; refused on a context block); Release drops the manual answer so AI
 * may fill the block again.
 *
 * @generated from message com.diagnocat.scribe.DocumentAnswerChange
 */
export const DocumentAnswerChange = proto3.makeMessageType(
  "com.diagnocat.scribe.DocumentAnswerChange",
  () => [
    { no: 1, name: "Key", kind: "message", T: DocumentAnswerKey },
    { no: 2, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Clear", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "Release", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "TeethGroups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 8, name: "Revert", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "ApplyCorrection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "DismissCorrection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "AddOwnOption", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "RemoveOwnOption", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "Date", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "None", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 15, name: "Marks", kind: "message", T: NoteToothMark, repeated: true },
    { no: 16, name: "Numbers", kind: "message", T: NoteNumberValue, repeated: true },
    { no: 17, name: "TableRows", kind: "message", T: NoteTableRowValue, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.NoteLineChange
 */
export const NoteLineChange = proto3.makeMessageType(
  "com.diagnocat.scribe.NoteLineChange",
  () => [
    { no: 1, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Op", kind: "enum", T: proto3.getEnumType(NoteLineOp) },
    { no: 3, name: "Note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.NoteSectionChange
 */
export const NoteSectionChange = proto3.makeMessageType(
  "com.diagnocat.scribe.NoteSectionChange",
  () => [
    { no: 1, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Op", kind: "enum", T: proto3.getEnumType(NoteSectionOp) },
    { no: 3, name: "LineIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * "+ Add line": a manual line of one text block.
 *
 * @generated from message com.diagnocat.scribe.NoteAddLine
 */
export const NoteAddLine = proto3.makeMessageType(
  "com.diagnocat.scribe.NoteAddLine",
  () => [
    { no: 1, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AfterLineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.NoteAddedBlockChange
 */
export const NoteAddedBlockChange = proto3.makeMessageType(
  "com.diagnocat.scribe.NoteAddedBlockChange",
  () => [
    { no: 1, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Op", kind: "enum", T: proto3.getEnumType(NoteAddedBlockOp) },
  ],
);

/**
 * At least one of Changes, LineChanges, SectionChanges, AddLines and
 * AddedBlockChanges is non-empty; the block-note lists and the own-option
 * changes are refused on a legacy note. All entries are validated first and one invalid entry refuses the
 * request. They are applied in this order: Changes, LineChanges,
 * AddedBlockChanges, AddLines, SectionChanges.
 *
 * @generated from message com.diagnocat.scribe.UpdateDocumentAnswersReq
 */
export const UpdateDocumentAnswersReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateDocumentAnswersReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "BaseRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Changes", kind: "message", T: DocumentAnswerChange, repeated: true },
    { no: 5, name: "LineChanges", kind: "message", T: NoteLineChange, repeated: true },
    { no: 6, name: "SectionChanges", kind: "message", T: NoteSectionChange, repeated: true },
    { no: 7, name: "AddLines", kind: "message", T: NoteAddLine, repeated: true },
    { no: 8, name: "AddedBlockChanges", kind: "message", T: NoteAddedBlockChange, repeated: true },
    { no: 9, name: "ClientTimeZone", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateDocumentAnswersResp
 */
export const UpdateDocumentAnswersResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateDocumentAnswersResp",
  () => [
    { no: 1, name: "Answers", kind: "message", T: DocumentAnswers },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteAIStepsReq
 */
export const ListNoteAIStepsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteAIStepsReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Before", kind: "message", T: Timestamp, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteAIStepsResp
 */
export const ListNoteAIStepsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteAIStepsResp",
  () => [
    { no: 1, name: "Steps", kind: "message", T: NoteAIStep, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ExportPartnerDocumentReq
 */
export const ExportPartnerDocumentReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ExportPartnerDocumentReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ExportPartnerDocumentResp
 */
export const ExportPartnerDocumentResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ExportPartnerDocumentResp",
  () => [
    { no: 1, name: "Partner", kind: "enum", T: proto3.getEnumType(PartnerTemplatePartner) },
    { no: 2, name: "Format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PlainText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Warnings", kind: "message", T: PartnerExportWarning, repeated: true },
    { no: 6, name: "Revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * PartnerExportWarning is one place where the exported text differs from the
 * note.
 *
 * @generated from message com.diagnocat.scribe.PartnerExportWarning
 */
export const PartnerExportWarning = proto3.makeMessageType(
  "com.diagnocat.scribe.PartnerExportWarning",
  () => [
    { no: 1, name: "Kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CompleteNoteReq
 */
export const CompleteNoteReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CompleteNoteReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CompleteNoteResp
 */
export const CompleteNoteResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CompleteNoteResp",
  () => [
    { no: 1, name: "Answers", kind: "message", T: DocumentAnswers },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.SetDocumentTemplateReq
 */
export const SetDocumentTemplateReq = proto3.makeMessageType(
  "com.diagnocat.scribe.SetDocumentTemplateReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "BaseRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.SetDocumentSectionsReq
 */
export const SetDocumentSectionsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.SetDocumentSectionsReq",
  () => [
    { no: 1, name: "EncounterID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DocumentID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "TemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Sections", kind: "message", T: EncounterDocumentSectionOverride, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.SetDocumentSectionsResp
 */
export const SetDocumentSectionsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.SetDocumentSectionsResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: EncounterDocument },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.SetDocumentTemplateResp
 */
export const SetDocumentTemplateResp = proto3.makeMessageType(
  "com.diagnocat.scribe.SetDocumentTemplateResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: EncounterDocument },
    { no: 2, name: "Answers", kind: "message", T: DocumentAnswers, opt: true },
    { no: 3, name: "LostManual", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

